import { PatentLegalStatus } from "./patent-status";
export default PatentLegalStatus;
